export default __webpack_public_path__ + "static/media/lg-b.49973a6c.jpg";